// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xx6u","name":"styles_name__2rvMT","phone":"styles_phone__3gSDf"};